import { AppliedWhen } from 'constants/assessment_types';
import { ProviderAssessmentCardProps } from 'types/cardProps';

const NST_LOWER_RANGE = 132;
const NST_UPPER_RANGE = 135;
const FALLS_ASSESSMENT_NUMBER = '100043';

export const shouldLoadAnswers = (content: ProviderAssessmentCardProps): boolean => {
  // Case: Falls assessment
  if ((content.assessmentNumber === FALLS_ASSESSMENT_NUMBER && content.appliedWhenID === AppliedWhen.ADMISSION && content.assessmentStatus === 'Completed')) {
    return true;
  }

  // Case: Core measures form
  if (content.isCoreMeasures && (content.assessmentStatus === 'Incomplete' || content.assessmentStatus === 'Completed')) {
    return true;
  }

  // Case: NST form
  if (content.instrumentTypeID >= NST_LOWER_RANGE && content.instrumentTypeID <= NST_UPPER_RANGE) {
    return true;
  }
  return false;
};
